import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideToastr } from 'ngx-toastr';
import { ToastrComponent } from './shared/components/toastr/toastr.component';
import { provideAnimations } from "@angular/platform-browser/animations";
import { providers } from './core/initializations/app-initialization.module';
import { provideHttpClient } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { TimeagoClock, TimeagoFormatter, TimeagoIntl, TimeagoModule } from 'ngx-timeago';
import { MyTimeagoFormatter } from './core/helpers/timeago-formatter';
import { MyClock } from './core/helpers/timeago-clock';
import { MyIntl } from './core/helpers/intl';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { customPresetColors } from './core/helpers/preset-prime-ng-colors';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
function playerFactory() {
  return player;
}
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(),
    importProvidersFrom(
      TranslateModule.forRoot({}),
      TimeagoModule.forRoot({
        intl: { provide: TimeagoIntl, useClass: MyIntl },
        clock: { provide: TimeagoClock, useClass: MyClock },
        formatter: { provide: TimeagoFormatter, useClass: MyTimeagoFormatter }
      })),
    provideLottieOptions({
      player: playerFactory,
    }),
    provideToastr({
      toastComponent: ToastrComponent,

      newestOnTop: true,
      preventDuplicates: true,
      progressBar: true,
      positionClass: 'toast-top-right',
    }),
    ...providers,
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: customPresetColors, options: { darkModeSelector: '.p-dark' }
      },
    }),
  ]
};
